export const NARROW = ['narrow'];
export const WIDE = ['wide'];
export const MODAL_MODIFIER = 'modal';
export const MODAL_MODIFIERS = ['modal'];
export const POSITION_FOR_TOGGLE_MODIFIER = 'positionForToggle';
export const MEDIUM_PADDING_MODIFIER = 'mediumPadding';
export const MEDIUM = 'medium';
export const SCROLL_CONTENT = 'scrollContent';
